module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade modal-user-edit",
    attrs: {
      "tabindex": "-1",
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('form', [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [(_vm.editingExistingUser) ? [_vm._v("Edit Account User")] : [_vm._v("Add Account User")]], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [(_vm.notEditingExistingUser) ? _c('p', {
    staticClass: "m-b-lg"
  }, [_vm._v("\n            You can add additional users to your account, this gives them full access to all areas except your master account settings and users.\n          ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    class: {
      'col-sm-12': _vm.notEditingExistingUser, 'col-sm-8': _vm.editingExistingUser
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-6"
  }, [_c('div', {
    staticClass: "form-group-outer"
  }, [_c('div', {
    staticClass: "form-group float-label-control",
    class: {
      'has-error': _vm.errors.has('name')
    }
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "float-label",
      rawName: "v-float-label"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Name",
      "name": "name"
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6"
  }, [_c('div', {
    staticClass: "form-group-outer"
  }, [_c('div', {
    staticClass: "form-group float-label-control",
    class: {
      'has-error': _vm.errors.has('surname')
    }
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Surname")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.surname),
      expression: "surname"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "float-label",
      rawName: "v-float-label"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Surname",
      "name": "surname"
    },
    domProps: {
      "value": (_vm.surname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.surname = $event.target.value
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group-outer"
  }, [_c('div', {
    staticClass: "form-group float-label-control",
    class: {
      'has-error': _vm.errors.has('email')
    }
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Email Address")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }, {
      name: "float-label",
      rawName: "v-float-label"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Email Address",
      "name": "email"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group-"
  }, [_c('div', {
    staticClass: "form-group float-label-control",
    class: {
      'has-error': _vm.errors.has('mobile')
    }
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Mobile Number")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.mobile),
      expression: "mobile"
    }, {
      name: "float-label",
      rawName: "v-float-label"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Mobile Number",
      "name": "mobile"
    },
    domProps: {
      "value": (_vm.mobile)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.mobile = $event.target.value
      }
    }
  })])])]), _vm._v(" "), (_vm.editingExistingUser) ? _c('div', {
    staticClass: "col-sm-4"
  }, [(_vm.accountUserDecorated.isEnabled) ? _c('ladda-button', {
    staticClass: "btn btn-block btn-sm m-b-sm btn-warning",
    attrs: {
      "button-type": "button",
      "on-click": _vm.handleDisableUser
    }
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" Disable User\n              ")]) : _c('ladda-button', {
    staticClass: "btn btn-block btn-sm m-b-sm btn-success",
    attrs: {
      "button-type": "button",
      "on-click": _vm.handleEnableUser
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v(" Enable User\n              ")]), _vm._v(" "), (_vm.accountUserDecorated.isNotArchived) ? _c('ladda-button', {
    staticClass: "btn btn-block btn-sm m-b-sm btn-danger",
    attrs: {
      "button-type": "button",
      "on-click": _vm.handleArchiveUser
    }
  }, [_c('i', {
    staticClass: "fa fa-trash"
  }), _vm._v(" Archive User\n              ")]) : _c('ladda-button', {
    staticClass: "btn btn-block btn-sm m-b-sm btn-success",
    attrs: {
      "button-type": "button",
      "on-click": _vm.handleRestoreUser
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v(" Restore User\n              ")])], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.editingExistingUser),
      expression: "editingExistingUser"
    }]
  }, [_c('strong', [_vm._v("Last access:")]), _vm._v(" " + _vm._s(_vm.accountUserDecorated.last_login) + "\n              ")]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.notEditingExistingUser),
      expression: "notEditingExistingUser"
    }],
    staticClass: "small"
  }, [_vm._v("\n                Note: When creating a new user an email will be sent to them so they can set their password.\n              ")]), _vm._v(" "), (_vm.editingOrCreateChildAdminAccount) ? [_c('div', {
    staticClass: "decorative-divider"
  }), _vm._v(" "), _c('h3', [_vm._v("System Access")]), _vm._v(" "), _c('div', {
    staticClass: "checkbox checkbox-primary"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.permissionLoadCheck),
      expression: "permissionLoadCheck"
    }],
    staticClass: "styled",
    attrs: {
      "id": "checkbox-load-check",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.permissionLoadCheck) ? _vm._i(_vm.permissionLoadCheck, null) > -1 : (_vm.permissionLoadCheck)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.permissionLoadCheck,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.permissionLoadCheck = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.permissionLoadCheck = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.permissionLoadCheck = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "checkbox-load-check"
    }
  }, [_vm._v("\n                    Load Check\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "checkbox checkbox-primary"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.permissionInvoices),
      expression: "permissionInvoices"
    }],
    staticClass: "styled",
    attrs: {
      "id": "checkbox-invoices",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.permissionInvoices) ? _vm._i(_vm.permissionInvoices, null) > -1 : (_vm.permissionInvoices)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.permissionInvoices,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.permissionInvoices = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.permissionInvoices = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.permissionInvoices = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "checkbox-invoices"
    }
  }, [_vm._v("\n                    Invoices\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "checkbox checkbox-primary"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.permissionPayments),
      expression: "permissionPayments"
    }],
    staticClass: "styled",
    attrs: {
      "id": "checkbox-payments",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.permissionPayments) ? _vm._i(_vm.permissionPayments, null) > -1 : (_vm.permissionPayments)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.permissionPayments,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.permissionPayments = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.permissionPayments = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.permissionPayments = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "checkbox-payments"
    }
  }, [_vm._v("\n                    Payments\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "checkbox checkbox-primary"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.permissionReports),
      expression: "permissionReports"
    }],
    staticClass: "styled",
    attrs: {
      "id": "checkbox-reports",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.permissionReports) ? _vm._i(_vm.permissionReports, null) > -1 : (_vm.permissionReports)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.permissionReports,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.permissionReports = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.permissionReports = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.permissionReports = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "checkbox-reports"
    }
  }, [_vm._v("\n                    Reports\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "checkbox checkbox-primary"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.permissionUsers),
      expression: "permissionUsers"
    }],
    staticClass: "styled",
    attrs: {
      "id": "checkbox-users",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.permissionUsers) ? _vm._i(_vm.permissionUsers, null) > -1 : (_vm.permissionUsers)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.permissionUsers,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.permissionUsers = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.permissionUsers = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.permissionUsers = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "checkbox-users"
    }
  }, [_vm._v("\n                    Users\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "checkbox checkbox-primary"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.permissionSettings),
      expression: "permissionSettings"
    }],
    staticClass: "styled",
    attrs: {
      "id": "checkbox-system-settings",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.permissionSettings) ? _vm._i(_vm.permissionSettings, null) > -1 : (_vm.permissionSettings)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.permissionSettings,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.permissionSettings = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.permissionSettings = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.permissionSettings = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "checkbox-system-settings"
    }
  }, [_vm._v("\n                    System Settings\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "checkbox checkbox-primary"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.permissionAdministrator),
      expression: "permissionAdministrator"
    }],
    staticClass: "styled",
    attrs: {
      "id": "checkbox-system-adminstrator",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.permissionAdministrator) ? _vm._i(_vm.permissionAdministrator, null) > -1 : (_vm.permissionAdministrator)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.permissionAdministrator,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.permissionAdministrator = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.permissionAdministrator = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.permissionAdministrator = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "checkbox-system-adminstrator"
    }
  }, [_vm._v("\n                    System Administrator\n                  ")])])] : _vm._e()], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Close")]), _vm._v(" "), (_vm.editingExistingUser) ? _c('ladda-button', {
    attrs: {
      "type": "primary",
      "size": "small",
      "on-click": _vm.handleSaveUser
    }
  }, [_vm._v("Save")]) : _c('ladda-button', {
    attrs: {
      "type": "primary",
      "size": "small",
      "on-click": _vm.handleAddUser
    }
  }, [_vm._v("Add User")])], 1)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../~/vue-loader/lib/template-compiler?{"id":"data-v-41caa22e"}!../~/vue-loader/lib/selector.js?type=template&index=0!./src/components/user/account-users/AccountUsersModal.vue
// module id = 977
// module chunks = 0